var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-auto max-w-large anchor",attrs:{"id":"speakers"}},[_c('SpeakerList',{attrs:{"active":true,"showHeader":true,"caption":_vm.options && _vm.options.label,"isStage":false,"listHeight":76.4,"stageFilterDesign":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }